import React, {useState, useEffect, useContext} from 'react'
import { IsLoggedContext } from '../Store'
import {Link} from 'react-router-dom'
import { config } from '../server'
const address = config.url.API_URL

const Space = (props) => {
    const space = props.match.params.spaceName
    const [spaceInfo, setSpaceInfo] = useState({})
    const [requested, setRequest] = useState(false)
    const [username] = useContext(IsLoggedContext)
    const [isMember, setIsMember] = useState(false)
    const [requests, setRequests] = useState(false)

    useEffect(() => {
        let mounted = true
        fetch(address + `/api/space/${space}`).then(res => res.json()).then(data => {
           // console.log(data.space[0])
            if(mounted) {
                setSpaceInfo(data.space[0])
            }
        })




        const getMembers = async () => {
            const res = await fetch(`${address}/api/${space}/members`)
            const data = await res.json()
            //console.log(data)
            if(mounted) {
                //setMembers(data.allMembers)
                for(let i = 0; i < data.allMembers.length; i++) {
                    if(data.allMembers[i].requestingUser === username) {
                        setIsMember(true)
                    }
                }
            }
        }
        const getRequests = async () => {
            const refetch = await fetch(address + `/api/${space}/spaceRequests`)
            const data = await refetch.json()
            if(mounted) {
                //setMembers(data.allMembers)
                for(let i = 0; i < data.allRequests.length; i++) {
                    if(data.allRequests[i].requestingUser === username) {
                        setRequests(true)
                        setRequest(true)
                    }
                }
            }
        }
        getMembers()
        getRequests()


        return () => {
            mounted = false
        }
    }, [space, username])

    const requestJoin = async (status) => {
        const requestOptions = {
            method: 'POST',
            headers: {
              'content-type': 'application/json' },
            body: JSON.stringify({ username: username, spaceName: space })
        };
        const requestOptions2 = {
            method: 'POST',
            headers: {
              'content-type': 'application/json' },
            body: JSON.stringify({ username: username })
        };
        if(status === 'requested') {
            await fetch(address + '/api/requestSpace', requestOptions)
            setRequest(!requested)
        } else if(status === 'unrequest'){
            await fetch(address + `/api/${space}/unrequest`, requestOptions2)
            setRequest(!requested)
        } else if(status === 'leave') {
            await fetch(address + `/api/${space}/unrequest`, requestOptions2)
            setIsMember(false)
        }
    }

    const publicConfirmation = async (decision, requestingUser) => {
        setIsMember(true)
        const requestOptions = {
            method: 'POST',
            headers: { 
              'content-type': 'application/json' },
            body: JSON.stringify({ owner: spaceInfo.owner, space: space,
                requestingUser: requestingUser, decision: decision })
        };
        //console.log(requestingUser)
        await fetch(address + '/confirmation', requestOptions)

    }

    return (
        <>
        {spaceInfo.owner === username && (
        <div>
        <div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-left">
						<h1 className="title">
                            {space}
						</h1>
					</div>
					<div className="level-left">
						<h2 className="subtitle">
                            {spaceInfo.description}
						</h2>
					</div>
                    <div className="level-left">
                        <button className="button is-danger">Share this link with friends to help set up tutoring sessions</button>
                    </div>
				</div>
			</div>
		</div>
        <div className="level">
        <div className="level-item has-background-link">
                <Link className="has-text-white"
                to={`/space/${space}/requests`}>Requests</Link>
            </div>
        </div>
        <div className="level">
        <div className="level-left">
            Reminders
        </div>
        <div className="level-item">
        <Link className="link" to={ {
          pathname: `/space/${space}/chat`}}>Chat</Link>
        </div>
        <div className="level-right">
        <Link className="link" to={ {
          pathname: `/space/${space}/members`}}>Members</Link>
        </div>
    </div>
    </div>
        )}
        {spaceInfo.privacy === 'private' && spaceInfo.owner !== username && (
            <div>
        <div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-left">
						<h1 className="title">
                            {space}
						</h1>
					</div>
					<div className="level-left">
						<h2 className="subtitle">
                            {spaceInfo.description}
						</h2>
					</div>
                    <div className="level-left">
                        {!requested && !isMember && !requests && <button className="button is-danger" onClick={() => requestJoin('requested')}>Request to join</button>}
                        {requested && !requests && <button onClick={() => requestJoin('unrequest')} className="button is-danger is-inverted">Requested</button>}
                        {requests && <button onClick={() => requestJoin('unrequest')} className="button is-danger is-inverted">Requested</button>}
                        {isMember && <button onClick={() => requestJoin('leave')} className="button is-danger is-inverted">Leave</button>}
                    </div>
				</div>
			</div>
		</div>
        {isMember && (
        <div className="level">
        <div className="level-left">
            Reminders
        </div>
        <div className="level-item">
        <Link className="link" to={ {
          pathname: `/space/${space}/chat`}}>Chat</Link>
        </div>
        <div className="level-right">
        <Link className="link" to={ {
          pathname: `/space/${space}/members`}}>Members</Link>
        </div>
    </div>
        )}
        {!isMember && (
            <div className="level">
                This space is private. Request the owner to join
            </div>
        )}
    </div>
        )}
        {spaceInfo.privacy === 'public' && spaceInfo.owner !== username && (
        <div>
        <div className="hero is-primary">
			<div className="hero-body">
				<div className="container">
					<div className="level-left">
						<h1 className="title">
                            {space}
						</h1>
					</div>
					<div className="level-left">
						<h2 className="subtitle">
                            {spaceInfo.description}
						</h2>
					</div>
                    <div className="level-left">
                        {!isMember && (
                        <button className="button is-danger"
                         onClick={() => publicConfirmation('public', username)}>Join</button>)
                        }
                        {isMember && <button onClick={() => requestJoin('leave')} className="button is-danger is-inverted">Leave</button>}
                    </div>
				</div>
			</div>
		</div>
        <div className="level">
            <div className="level-left">
                Reminders
            </div>
            <div className="level-item">
            <Link className="link" to={ {
              pathname: `/space/${space}/chat`}}>Chat</Link>
            </div>
            <div className="level-right">
            <Link className="link" to={ {
              pathname: `/space/${space}/members`}}>Members</Link>
            </div>
        </div>
        </div>
        )}
        </>
    )
}

export default Space
